module.exports = __webpack_public_path__ + "media/images/games/k2gender/blue-dc09e276cf11ed8e3dfb28de946a62b3.png";